<script>
import ieVerify from '@/views/cargo/v0/Integrated/ieVerify'

export default {
  name: 'ICIEVerify',
  extends: ieVerify,
  props: {
    integratedLogisticsType: {
      type: String,
      default: 'IC' // 设置默认值
    }
  }
}
</script>
